/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* eslint-disable no-unused-vars */
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import getConfig from '../../../config';
import {assetsConfiguration} from './RecentWorkConstants';
import HomeAnalytics from '../../containers/Home/Analytics/HomeAnalytics';
import RecentAssetsView from 'recent-assets';
import RecentFilesView from 'recent-files';
import SearchHostContext from '../../containers/Search/SearchHostContext';
import {fileConfigPs} from './AppHome/PsFilePickerConfig';
import {fileConfigAi} from './AppHome/AiFilePickerConfig';
import {fileConfigFred} from './AppHome/FredFilePickerConfig';

/* eslint-enable no-unused-vars */
import './RecentWork.scss';

type Props = {
	env: string;
	locale: string;
	shiftRecentsToBottom: Function;
	sapcode?: string;
	createSpacesCallback: Function;
	ccProjectsFetchFinished: boolean;
};

const clientIdMap = {
	PHSP: 'Charlotte',
	FRED: 'Fred',
	ILST: 'Venus',
};

declare let adobeIMS: AdobeIMS;

class RecentWork extends PureComponent<Props> {
	getIMSData() {
		let userId;
		if (adobeIMS.getUserProfile()) {
			userId = adobeIMS.getUserProfile()?.authId || adobeIMS.getUserProfile()?.userId;
		}
		const imsData: genericObject = {};
		imsData.token = adobeIMS.getAccessToken();
		imsData.id = userId;
		return imsData;
	}

	getClientId() {
		return window.CONFIG.CLIENT_ID;
	}

	getCCSApiKey() {
		return 'CCHomeRecent';
	}

	render() {
		const getFilePickerConfig = () => {
			const {sapcode, ccProjectsFetchFinished} = this.props;
			switch (sapcode) {
				case 'PHSP':
					return fileConfigPs;
				case 'ILST':
					return fileConfigAi;
				case 'FRED':
					fileConfigFred.newFileButtonProps.disabled = !ccProjectsFetchFinished;
					return fileConfigFred;
			}
			return null;
		};
		const hasLeftRail
			= window.cchome.util.hasFeature('apphomes') || window.cchome.util.hasFeature('home_left_rail');
		if (hasLeftRail) {
			assetsConfiguration.clientInfo.clientVersion = '1.1.0'; // To enable space features
		}
		else {
			assetsConfiguration.clientInfo.clientVersion = '1.0.0';
		}
		const searchHostContext = new SearchHostContext();
		const config = {
			assetsConfiguration,
			filePickerConfig: getFilePickerConfig(),
			callbacks: {
				onErrorCallback: this.props.shiftRecentsToBottom,
				utilsCallback: window.cchome.util,
			},
			maxRows: 1,
			maxItemsPerRow: 5,
			minItemsPerRow: 2,
			displayConfig: {
				offline: {},
				error: {},
				empty: {},
				heading: {
					buttons: [{}],
				},
			},
		};
		// Handle new item callback
		if (config.filePickerConfig) {
			if (this.props.sapcode === 'FRED') {
				// @ts-ignore
				config.filePickerConfig.emptyStateComponentProps = this.props.createSpacesCallback;
			}
			config.filePickerConfig.newFileCallback = () => {
				if (this.props.sapcode === 'FRED') {
					this.props.createSpacesCallback();
				}
				else if (this.props.sapcode === 'ILST') {
					window.open(`${getConfig('ILLUSTRATOR_WEB')}new`, '_self');
				}
				else if (this.props.sapcode === 'PHSP') {
					window.open(`${getConfig('PHOTOSHOP_WEB')}new`, '_self');
				}
			};
		}
		const getCacheId = () => (this.props.sapcode && clientIdMap[this.props.sapcode] ? clientIdMap[this.props.sapcode] : 'CCHome');
		let RecentView = RecentAssetsView;
		if (window.cchome.util.hasFeature('apphomes')) {
			RecentView = RecentFilesView;
			config.displayConfig.heading.buttons = [];
		}
		else {
			RecentView = RecentAssetsView;
			config.assetsConfiguration.limit = 5;
		}
		return (
			<RecentView
				environment={this.props.env}
				imsData={this.getIMSData()}
				locale={this.props.locale}
				apiKey={this.getClientId()}
				ccsApiKey={this.getCCSApiKey()}
				config={config}
				clientId={getCacheId()}
				clientHostContext={searchHostContext}
				isleftNavOpen={this.props.isleftNavOpen}
				featureFlags={window.cchome.util.getAllFeatures()}
				assetsContainerClassName='recent-work-container-top home-component'
				errorContainerClassName='recent-work-container-bottom home-component'
			/>
		);
	}
}

function mapStateToProps(state) {
	return {
		ccProjectsFetchFinished: state.appHome.ccProjectsFetchFinished,
	};
}

export default connect(mapStateToProps)(RecentWork);
